import React from "react";
import "./Footer.css";
import logo from "../../assets/logo.png";
import linkedin from "../../assets/linkedin.png";
import instgram from "../../assets/instagram.png";
import github from "../../assets/github.png";

const Footer = () => {
  return (
    <div className="footer">
      <div className="blur blur-footer-1"></div>
      <div className="blur blur-footer-2"></div>
      <div className="icons">
        <a href="https://github.com/MoYehiair?tab=repositories" target="_blank">
          <img src={github} alt="" />
        </a>
        <a href="https://www.instagram.com/" target="_blank">
          <img src={instgram} alt="" />
        </a>
        <a
          href="https://www.linkedin.com/in/mohamed-yehia-57a076111/"
          target="_blank"
        >
          <img src={linkedin} alt="" />
        </a>
      </div>
      <div>
        <img className="logo" src={logo} alt="" />
      </div>
    </div>
  );
};

export default Footer;
